<script lang="ts">
  import type { Product } from '$lib/types';
  import { sanitiseAdditionalCategories } from '$lib/utils/productCategories';
  let { product }: { product: Pick<Product, 'category' | 'additional_categories'> } = $props();
  const additional = $derived(sanitiseAdditionalCategories(product.category, product.additional_categories));
</script>
<span class="mt-1 flex flex-wrap gap-1 text-xs">
  <span class="tym-badge tym-badge-neutral !text-[10px]" title="Primary category"><span class="sr-only">Primary: </span>{product.category || 'Uncategorised'}</span>
  {#each additional as category}<span class="tym-badge tym-badge-neutral !text-[10px]" title="Also listed under"><span class="sr-only">Also listed under: </span>{category}</span>{/each}
</span>
